export const publicData={
    // logo:require("@/assets/img/logo.png"),
    projectName:'分享页面',
    getComArgs: process.env.NODE_ENV === 'development'? "token=591ead6e-5af9-4bd0-a329-0f6a7cf03a2c&udid=945e2f612b341121c6003e69448a3cf4&productId=dafa0e90-0320-476f-a35b-99788ef64954&vestId=3fa587b7-e77d-43ee-b833-071f9493c873&channel=test&osType=android&version=1":"token=591ead6e-5af9-4bd0-a329-0f6a7cf03a2c&udid=945e2f612b341121c6003e69448a3cf4&productId=dafa0e90-0320-476f-a35b-99788ef64954&vestId=3fa587b7-e77d-43ee-b833-071f9493c873&channel=test&osType=android&version=1",
    // environment:process.env.NODE_ENV === 'development'?true:false,
}



// WEBPACK FOOTER //
// ./src/utils/publicData.js